import React, { useState, useEffect } from 'react';
import ReactPlaceholder from 'react-placeholder';
import "react-placeholder/lib/reactPlaceholder.css";

function joinNow(props) {

    const [ready, setReady] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setReady(true)
        }, 1000);
    }, [])

    return (
        <>
            <div className="full-small-section">
                <div className="section-gap">
                    <div className="container">
                        <div className="card small-section-wrapper text-center">
                            <div className="card-body ">
                                <ReactPlaceholder showLoadingAnimation ready={ready} type="rect" style={{ height: "100px" }}>

                                    <div className="text-white weight-cart">
                                        <h2 className="text-cart">
                                            Take Your First Step <span className="text-dark">Today</span>
                                        </h2>
                                    </div>
                                    {props && props?.variant && props?.variant.toLowerCase() === "generic" ?
                                        <button
                                            className="btn btn-lg-primary btn-primary  col-md-3"
                                            style={{ cursor: "pointer" }}
                                            onClick={(e) =>

                                                props.goToCheckout({
                                                    img: "v1678202048/NextMed/GLP_-_1_gcunmh.png",
                                                    name: "Semaglutide Weight Loss Program",
                                                    type: "weightloss",
                                                    price: 479,
                                                    weightlossKey: "price_1KtmcDDM8fNsPiHlo9lXPoX9",
                                                    month: 1,
                                                })
                                            }
                                        >   {props.variant == "2wk" ? "Start 14 Day Free Trial" : "Join Now"}</button> :
                                        <button
                                            className="btn btn-lg-primary btn-primary  col-md-3"
                                            style={{ cursor: "pointer" }}
                                            onClick={(e) =>

                                                props.goToCheckout({
                                                    img: "v1678202048/NextMed/GLP_-_1_gcunmh.png",
                                                    name: "Wegovy Weight Loss Program",
                                                    type: "weightloss",
                                                    price: props.variant ? 199 : 199,
                                                    weightlossKey: "price_1KtmcDDM8fNsPiHlo9lXPoX9",
                                                    month: 1,
                                                })
                                            }
                                        >
                                            {props.variant == "2wk" ? "Start 14 Day Free Trial" : "Join Now"}
                                        </button>
                                    }
                                </ReactPlaceholder>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default joinNow
